import React from 'react';
import ReactDOM from 'react-dom';
import HeroCarousel from '../components/HeroCarousel';
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderHeroCarousel = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (element) {
    initializeI18n()
      .then(() => {
        ReactDOM.render(<HeroCarousel props={props} />, element);
      })
      .catch(() => {});
  }
};
